import { render, staticRenderFns } from "./BoxR.vue?vue&type=template&id=5b1bf1b8&scoped=true&lang=pug"
import script from "./BoxR.vue?vue&type=script&lang=js"
export * from "./BoxR.vue?vue&type=script&lang=js"
import style0 from "./BoxR.styl?vue&type=style&index=0&id=5b1bf1b8&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1bf1b8",
  null
  
)

export default component.exports